<app-view-title class="title-container" [title]="createOrgTitle | translate"></app-view-title>
@if (isSubOrgCreation && (selectedTenant$ | async)) {}
<div class="create-org">
  <div class="content-container">
    <form *ngIf="(userLoaded$ | async) && (getApps$ | async)" [formGroup]="createTenantForm">
      <div>
        <span class="org-details-title">
          {{ orgTitle | translate }}
          <i
            class="ra-icon-ide-md-info ra-common-icon tooltip-icon"
            [raUiTooltip]="titleTooltip | translate"
            [tooltipConfig]="tooltipConfig"
          ></i
        ></span>
      </div>
      <div class="org-logo-row">
        <div class="org-logo">
          <img
            *ngIf="selectedOrgImage !== 'assets/images/org-logo-blank.svg'"
            id="edit-org-logo-img"
            src="{{ selectedOrgImage }}"
            alt="Organization Logo"
            (error)="orgImageError()"
          />
          <i
            *ngIf="selectedOrgImage === 'assets/images/org-logo-blank.svg'"
            id="edit-org-blank-logo-img"
            class="ra-icon-ide-xl-team team-org"
            alt="Organization Logo"
          ></i>
        </div>
        <ra-ui-file-input
          id="create-org-logo"
          #fileInput
          [buttonLabel]="addOrgLogoText | translate"
          [config]="{
            isDirectory: false,
            isMultiple: false,
            supportedFilesTypes: 'image/x-png,image/jpeg',
            disableSidePaddings: true,
            useButtonStyle: true,
            hideFileList: true,
          }"
          (valueChange)="onSelectFiles($event); clearInput.click()"
          ngDefaultControl
        ></ra-ui-file-input>
        <a title="Clear" href="javascript:void(0)"
          ><span #clearInput hidden (click)="fileInput.value = []" onkeypress="">Clear</span>
        </a>
      </div>
      <div class="org-form-fields-container">
        <div class="org-form-field">
          <ra-ui-input
            #orgName
            id="create-org-name"
            formControlName="tenantName"
            placeholder="{{ 'fthub.input_text' | translate }}"
            maxlength="{{ MAX_NAME_LENGTH }}"
            label="{{ nameOfOrg | translate }}"
            required
            [errorMessages]="tenantNameErrorMsgs"
            [hintMessageEnd]="getInputHint(createTenantForm.get('tenantName')?.value, MAX_NAME_LENGTH)"
            [config]="{ fillParent: true, removeMessageSpace: false }"
            ngDefaultControl
          ></ra-ui-input>
        </div>

        <div class="org-form-field">
          <ra-ui-input
            id="create-org-tenant-owner-name"
            formControlName="tenantOwnerName"
            placeholder="{{ 'fthub.input_text' | translate }}"
            label="{{ 'fthub.owner_name' | translate }}"
            [disabled]="true"
            [config]="{ fillParent: true, removeMessageSpace: false }"
            ngDefaultControl
          ></ra-ui-input>
        </div>

        <div *ngIf="!isSubOrgCreation" class="org-form-field">
          <ra-ui-input
            id="create-org-email"
            formControlName="tenantEmailDomain"
            placeholder="{{ 'fthub.input_text' | translate }}"
            label="{{ 'fthub.email_domain' | translate }}"
            [disabled]="true"
            [config]="{ fillParent: true, removeMessageSpace: false }"
            ngDefaultControl
          ></ra-ui-input>
        </div>

        <div class="org-form-field">
          <ra-ui-input
            #location
            id="create-org-location"
            formControlName="location"
            placeholder="{{ 'fthub.input_text' | translate }}"
            maxlength="{{ MAX_LOCATION_LENGTH }}"
            label="{{ 'fthub.location' | translate }}"
            [config]="{ fillParent: true, removeMessageSpace: false }"
            [hintMessageEnd]="getInputHint(createTenantForm.get('location')?.value, MAX_LOCATION_LENGTH)"
            [errorMessages]="tenantLocationErrorMsgs"
            ngDefaultControl
          ></ra-ui-input>
        </div>

        <div class="org-form-field">
          <ra-ui-multiline-input
            #description
            id="create-org-description"
            label="{{ 'fthub.description' | translate }}"
            maxlength="{{ MAX_DESCRIPTION_LENGTH }}"
            formControlName="tenantDescription"
            placeholder="{{ 'fthub.input_text' | translate }}"
            [config]="{ isAutoSizeTextArea: false, fillParent: true, minRows: 1, maxRows: 5 }"
            [hintMessageEnd]="getInputHint(createTenantForm.get('tenantDescription')?.value, MAX_DESCRIPTION_LENGTH)"
            [errorMessages]="tenantDescriptionErrorMsgs"
            ngDefaultControl
          ></ra-ui-multiline-input>
        </div>
      </div>
      <ra-ui-divider *ngIf="!isSubOrgCreation"></ra-ui-divider>
      @if (isPrivateDomain && !isSubOrgCreation) {
        <div class="org-visibility-container">
          <div class="org-visibility-title">Organization Access</div>
          <ra-ui-checkbox
            id="create-org-visibility"
            formControlName="visibility"
            ngDefaultControl
            [label]="orgVisibilityCheckboxLabel"
          ></ra-ui-checkbox>
          @if (!createTenantForm.get('visibility')?.value) {
            <div class="org-visibility-instruction">
              <i class="ra-icon-ide-md-lock"></i>Only people you invite will be able to join
            </div>
          }
        </div>
      }
    </form>
  </div>
  <div class="footer-container button-group">
    <ra-ui-main-button
      id="createorg-next-btn"
      label="{{ 'fthub.create' | translate }}"
      (click)="isSubOrgCreation ? createSubOrg() : createOrg()"
      [disabled]="!createTenantForm.valid"
      onkeypress=""
    >
    </ra-ui-main-button>
    <ra-ui-outlined-button
      id="createorg-cancel"
      label="{{ 'fthub.cancel' | translate }}"
      (click)="cancelOrgCreation()"
      onkeypress=""
    ></ra-ui-outlined-button>
  </div>
  @if (newTenantCreated$ | async) {}
  <ng-template #orgCreatedSuccess>
    <div class="create-org-done-container">
      <img [src]="'/assets/images/star-celebration.svg'" alt="Congratulations" />
      <div>
        <div class="org-created-msg">
          {{ 'fthub.org_created_successfully_msg' | translate: { value: newTenantName } }}
        </div>
        <div class="org-sub-title">
          <span>
            {{ 'fthub.org_owner_msg' | translate: { value: newTenantName } }}
          </span>
          <span>
            {{ orgFinishSetupMsg | translate }}
          </span>
        </div>
      </div>
    </div>
    <div class="button-section">
      <ra-ui-main-button
        id="createorg-allocate-btn"
        label="{{ 'fthub.allocate_entitlements' | translate }} "
        (click)="allocateEntitlements()"
        onkeypress=""
      >
      </ra-ui-main-button>
      <ra-ui-outlined-button
        id="createorg-invite-btn"
        label="{{ 'fthub.invite_users' | translate }}"
        (click)="inviteUsers()"
        onkeypress=""
      >
      </ra-ui-outlined-button>
      <ra-ui-outlined-button
        id="createorg-close-btn"
        label="{{ 'fthub.close' | translate }}"
        (click)="closeSuccessDialog()"
        onkeypress=""
      ></ra-ui-outlined-button>
    </div>
  </ng-template>
</div>
